import { makeImmutable } from "../core";
import { CrossSellingList, } from "../ordering";
import { RArray } from "../collections";
export class CrossSellingListParser {
    constructor(productInstanceParser) {
        this.productInstanceParser = productInstanceParser;
        makeImmutable(this);
    }
    parse(crossSellingListId, crossSellingList) {
        return new CrossSellingList({
            id: crossSellingListId,
            items: new RArray(crossSellingList.items).mapOptional(([productInstanceId, crossSellingListItem]) => this.productInstanceParser.parseInstance(productInstanceId, crossSellingListItem.content)),
        });
    }
}
